import proj4 from 'proj4';
import inside from '@turf/boolean-point-in-polygon';
import geojsonWorld from './countries.geo.json';

const geojsonToMultiPolygons = (geojson) => {
  const coordinates = geojson.features.reduce(
    (poly, feature) =>
      poly.concat(
        feature.geometry.type === 'Polygon'
          ? [feature.geometry.coordinates]
          : feature.geometry.coordinates,
      ),
    [],
  );
  return { type: 'Feature', geometry: { type: 'MultiPolygon', coordinates } };
};

export function getPin( lat, lng, height, width ) {

  const DEFAULT_WORLD_REGION = {
    lat: { min: -56, max: 71 },
    lng: { min: -179, max: 179 },
  };

  let geojson = geojsonWorld;
  const region = DEFAULT_WORLD_REGION;
  const poly = geojsonToMultiPolygons(geojson);
  let grid = 'vertical';

  const ystep = grid === 'diagonal' ? Math.sqrt(3) / 2 : 1;

  const [X_MIN, Y_MIN] = proj4(proj4.defs('GOOGLE'), [
    region.lng.min,
    region.lat.min,
  ]);
  const [X_MAX, Y_MAX] = proj4(proj4.defs('GOOGLE'), [
    region.lng.max,
    region.lat.max,
  ]);
  const X_RANGE = X_MAX - X_MIN;
  const Y_RANGE = Y_MAX - Y_MIN;

  const [googleX, googleY] = proj4(proj4.defs('GOOGLE'), [lng, lat]);

  let [rawX, rawY] = [
    (width * (googleX - X_MIN)) / X_RANGE,
    (height * (Y_MAX - googleY)) / Y_RANGE,
  ];
  const y = Math.round(rawY / ystep);
  if (y % 2 === 0 && grid === 'diagonal') {
    rawX -= 0.5;
  }
  const x = Math.round(rawX);
  let [localx, localy] = [x, Math.round(y) * ystep];
  if (y % 2 === 0 && grid === 'diagonal') {
    localx += 0.5;
  }

  const [localLng, localLat] = proj4(
    proj4.defs('GOOGLE'),
    proj4.defs('WGS84'),
    [
      (localx * X_RANGE) / width + X_MIN,
      Y_MAX - (localy * Y_RANGE) / height,
    ],
  );

  const pin = { x: localx, y: localy, lat: localLat, lng: localLng };

  return pin;
}
